export const notifyMessage = {
  title: 'Progress saved!',
  message: 'Remember to complete the form later.',
  showClose: false,
  duration: 4000,
}

export default {
  data() {
    return {
      hasUnsavedDetailsChanges: false,
      hasUnsavedPeriodChanges: false,
      message: notifyMessage,
    }
  },
  async beforeRouteUpdate(to, from, next) {
    if (to.query?.step === undefined && Number(from.query.step) === 1) {
      if (to.query.campaign !== from.query.campaign) {
        const updatedQuery = {
          ...to.query,
          campaign: from.query.campaign,
        }

        this.$router
          .replace({ query: updatedQuery })
          .then(() => {
            next()
          })
          .catch((err) => {
            console.error(err)
            next()
          })
        return
      }
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    return this.handleRouteLeaveUpdate(next, to, from)
  },
  watch: {
    '$route.query.step': {
      async handler(step, oldStep) {
        step = step === undefined ? 0 : Number(step)
        const isBack = oldStep > step

        //if (isBack) {
        //  await this.updateStoreFormDetails(false)
        this.handlerStep(step)
        //}
      },
    },
  },
  methods: {
    onChange(data) {
      if (this.currentStep == 0) {
        this.hasUnsavedDetailsChanges = data.details.name !== '' && data.details.client !== '' && data.details.inventory !== ''
      } else if (this.currentStep == 1) {
        this.hasUnsavedPeriodChanges = data.period.startDate !== '' && data.period.endDate !== '' && data.period.budget !== ''
      } else {
        this.hasUnsavedDetailsChanges = false
        this.hasUnsavedPeriodChanges = false
      }
    },
    async handleRouteLeaveUpdate(next, to, from) {
      const campaign = this.$store.getters['socialBoostCampaign/campaign']

      if (this.type === 'simple') {
        if (this.hasUnsavedDetailsChanges && to.name === 'all' && this.currentStep === 0) {
          if (campaign?.is_draft || campaign?.is_draft === undefined) {
            this.$notify.info(this.message)
            const res = await this.$refs.formDetails.saveData(true)
          }
        } else if (this.hasUnsavedPeriodChanges && to.name === 'all' && this.currentStep === 1) {
          if (campaign?.is_draft || campaign?.is_draft === undefined) {
            this.$notify.info(this.message)
            const res = await this.$refs.formPeriod.saveData(false)
          }
        }
      }

      this.$store.commit('socialBoostCampaign/CLEAR_CAMPAIGN_FORM')
      this.$store.commit('socialBoostCampaign/SET_CAMPAIGN', false)
      this.$store.commit('socialBoostCampaign/SET_FLIGHT', false)

      next()
    },
  },
}
